import { useLayoutEffect, useState } from 'react'

import RunnerGoalShopping from '@/components/Runner/RunnerGoalShopping'
import RunnerTimer from '@/components/Runner/RunnerTimer'
import { useRunnerState } from '@/composables/useRunnerState'

import RunnerGoal from './RunnerGoal'
import RunnerJauge from './RunnerJauge'
import RunnerUIPedroTimeline from './RunnerUIPedroTimeline'

export default function RunnerUIHeader() {
  const { context, isIdle, isLoading, isPopin, persona, scenario, gameState } = useRunnerState()

  const segment = context.game.currentSegment
  const isPedro1 = scenario === 0 && persona === 'pedro'
  const isFrancesca2 = persona === 'francesca' && scenario === 1

  // const hide = gameState.paused;
  // DEBUG Only
  const hide = false

  const [showTimer, setShowTimer] = useState(false)
  const [isBrokenTimer, setIsBrokenTimer] = useState(false)

  useLayoutEffect(() => {
    const hidden = ['loading', 'introduction', 'audio_intro', 'popin1', 'audio_mother_intro']

    if (!isPedro1) {
      setShowTimer(false)
      setIsBrokenTimer(false)
    } else {
      if (segment == 'breakfast_milk') {
        setIsBrokenTimer(true)
      }
      setShowTimer(!hidden.includes(segment))
    }
  }, [isPedro1, segment, setShowTimer, setIsBrokenTimer])

  return (
    <header
      className={`RunnerUIHeader fixed z-100 top-0 left-0 w-full px-52 pt-12 pointer-events-none grid grid-cols-[20vw_1fr_20vw] min-h-120 transition-opacity duration-500 ease-out-quad ${hide ? 'opacity-0' : ''}`}
    >
      <div className='flex items-center *:pointer-events-auto'>{/* <RunnerShoppingCart /> */}</div>
      <div className='flex justify-center items-center *:pointer-events-auto min-h-120'>
        {!isFrancesca2 && <RunnerGoal />}
        {isFrancesca2 && <RunnerGoalShopping />}
      </div>
      <div className='hidden md:flex flex-row-reverse items-center *:pointer-events-auto'>
        <RunnerTimer
          className='-mr-10 w-[150px] self-start'
          show={showTimer && !isIdle && !isLoading}
          play={showTimer && !isIdle && !isPopin && !isLoading}
          isBroken={isBrokenTimer}
        />
        <RunnerJauge />
        <RunnerUIPedroTimeline />
      </div>
    </header>
  )
}
